import React from 'react'
import ReactDOM from 'react-dom'
import './styles/bootstrap.min.css'
import './styles/scss/style.scss'
import App from './App'
import { Provider } from 'react-redux'
import configureStore from './redux/store'
import { PersistGate } from 'redux-persist/integration/react'
import { persistStore } from 'redux-persist'

const store = configureStore()

const persistor = persistStore(store)

ReactDOM.render(
	<Provider store={store}>
		<PersistGate persistor={persistor}>
			<App />
		</PersistGate>
	</Provider>,
	document.getElementById('root')
)
